<template>
  <div class="order-detail">
    <div class="order-detail__header-block block-order-id">
      <span class="label">{{ $t('order.order') }}</span>
      <span class="text">{{order.increment_id}}</span>
    </div>
    <div class="order-detail__header-block block-shipping">
      <span class="label">{{ $t('order.shipping-method') }}</span>
      <span class="text">{{ order.shipping_method }} {{ order.shipping_description }}</span>
    </div>
    <div class="order-detail__header-block block-payment">
      <span class="label">{{ $t('order.payment-method') }}</span>
      <div class="text">
        <ul class="nav flex-column">
          <li v-for="method in order.payment.methods" :key="method">{{ $t(`payment-methods.${method}`) }}</li>
        </ul>
      </div>
    </div>
    <div class="order-detail__header-block block-giftcode" v-show="giftCodes.length">
      <span class="label">{{ $t('order.gift-code') }}</span>
      <div class="text">
        <ul class="nav flex-column">
          <li v-for="gift in giftCodes" :key="gift">{{ gift }}</li>
        </ul>
      </div>
    </div>
    <!-- <div class="order-detail__header-block block-discount">
      <span class="label">{{ $t('order.discount') }}</span>
      <span class="text">{{ order.discount_amount | price($store) }}</span>
    </div> -->
    <div class="order-detail__header-block block-grand-total">
      <span class="label">{{ $t('order.total') }}</span>
      <span class="text">{{order.grand_total | price($store) }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderDetail',
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isCollapsed: false
    }
  },
  computed: {
    giftCodes () {
      if (this.order && this.order.extension_attributes && this.order.extension_attributes.giftcards) {
        return this.order.extension_attributes.giftcards
      } else {
        return []
      }
    },
    phoneNumber () {
      if (this.order && Object.keys(this.order.billing_address).length > 0) {
        return this.order.billing_address.telephone || this.$t('not-specified')
      } else {
        return this.$t('not-specified')
      }
    }
  }
}
</script>
